import _ from '@luna/lodash';
import type { COUNTRY } from '@shared/core-types';

import type { MiscellaneousFeatures } from '../types/MiscellaneousFeatures';
import { miscellaneous as base } from './base';
import { miscellaneous as AT } from './countries/AT';
import { miscellaneous as CZ } from './countries/CZ';
import { miscellaneous as HR } from './countries/HR';
import { miscellaneous as HU } from './countries/HU';
import { miscellaneous as RO } from './countries/RO';
import { miscellaneous as SK } from './countries/SK';
import { miscellaneous as RS } from './countries/RS';

export const features: Record<COUNTRY, MiscellaneousFeatures> = {
    AT: _.merge({}, base, AT),
    CZ: _.merge({}, base, CZ),
    HR: _.merge({}, base, HR),
    HU: _.merge({}, base, HU),
    RO: _.merge({}, base, RO),
    SK: _.merge({}, base, SK),
    RS: _.merge({}, base, RS),
};
